/* tslint:disable */
/* eslint-disable */
/**
 * P4m.Module.Auth.API
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: v1
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from '../runtime';
/**
 * 
 * @export
 * @interface ExtensionDto
 */
export interface ExtensionDto {
    /**
     * 
     * @type {number}
     * @memberof ExtensionDto
     */
    id: number;
    /**
     * 
     * @type {string}
     * @memberof ExtensionDto
     */
    alias: string;
    /**
     * 
     * @type {string}
     * @memberof ExtensionDto
     */
    name?: string | null;
}

/**
 * Check if a given object implements the ExtensionDto interface.
 */
export function instanceOfExtensionDto(value: object): value is ExtensionDto {
    if (!('id' in value) || value['id'] === undefined) return false;
    if (!('alias' in value) || value['alias'] === undefined) return false;
    return true;
}

export function ExtensionDtoFromJSON(json: any): ExtensionDto {
    return ExtensionDtoFromJSONTyped(json, false);
}

export function ExtensionDtoFromJSONTyped(json: any, ignoreDiscriminator: boolean): ExtensionDto {
    if (json == null) {
        return json;
    }
    return {
        
        'id': json['id'],
        'alias': json['alias'],
        'name': json['name'] == null ? undefined : json['name'],
    };
}

export function ExtensionDtoToJSON(json: any): ExtensionDto {
    return ExtensionDtoToJSONTyped(json, false);
}

export function ExtensionDtoToJSONTyped(value?: ExtensionDto | null, ignoreDiscriminator: boolean = false): any {
    if (value == null) {
        return value;
    }

    return {
        
        'id': value['id'],
        'alias': value['alias'],
        'name': value['name'],
    };
}

